import { apiClient } from '../../config/axios.config';
import { BASE_TICKET_URL, BASE_URL } from '../apiConfig';

// Create Ticket with files
export const createTicket = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/create`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response;
};

// Fetch Ticket Listing
export const fetchTicketDetailsListing = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/list`,
    payload,
  );
  return response;
};

// Fetch Ticket by Ticket No
export const fetchTicketByTicketNo = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/trans`,
    payload,
  );
  return response;
};

// Update Ticket (status)
export const updateTicket = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/update`,
    payload,
  );
  return response;
};

// Update Ticket List
export const updateTicketList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/update-list`,
    payload,
  );
  return response;
};

// Cancel Ticket
export const cancelMyTicket = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/cancel-my-ticket`,
    payload,
  );
  return response;
};

// Ticket Responses =================================

// Create Ticket Response with files
export const createTicketResponse = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/response/create`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response;
};

// Fetch Ticket Response Listing
export const fetchTicketResponseListing = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/response/list`,
    payload,
  );
  return response;
};

// Fetch Ticket Response by Ticket No
export const deleteTicketResponse = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/response/delete`,
    payload,
  );
  return response;
};

// DOwnload attachement
export const downloadTicketAttachment = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TICKET_URL}/download-attachment`,
    payload,
    {
      responseType: 'blob',
    },
  );
  return response;
};

// Get COunt of Tickets
export const getTicketsCount = async () => {
  const response = await apiClient.get(`${BASE_URL}${BASE_TICKET_URL}/count`);
  return response;
};

// Get Ticket Status
export const fetchTicketStatus = async () => {
  const response = await apiClient.get(`${BASE_URL}${BASE_TICKET_URL}/status`);
  return response;
};
